
<script>
import moment from 'moment'

export default {
  props: ['event', 'date', 'firstDay', 'listStyle'],
  computed: {
    cssClasses () {
      let cssClasses = this.event.cssClass

      if (!Array.isArray(cssClasses)) {
        cssClasses = [cssClasses]
      } else {
        cssClasses = Array.from(cssClasses)
      }

      if (this.start.isSame(this.date, 'day')) {
        cssClasses.push('is-start')
      }

      if (this.end.isSame(this.date, 'day')) {
        cssClasses.push('is-end')
      }

      if (!this.event.isShow) {
        cssClasses.push('is-opacity')
      }

      if (this.event.isOpen) {
        cssClasses.push('F3-M-14')
      } else {
        cssClasses.push('F7-M-14')
      }

      return cssClasses.join(' ')
    },
    showTitle () {
      return (this.date.day() === this.firstDay || this.start.isSame(this.date, 'day'))
    },
    start () {
      return moment(this.event.start)
    },
    end () {
      return moment(this.event.end)
    }
  }
}
</script>

<template>
    <!-- <router-link style="text-decoration:none;" to="/test1"> -->
    <!-- event-card中显示无序列表，是否有序号判断 -->
    <div class="event-div">
      <li class="event-item" :class="cssClasses" :title="event.title" v-if="listStyle">
            {{ event.title }}
      </li>
      <li style="list-style-type:none" class="event-item" :class="cssClasses" :title="event.title" v-else>
            {{ event.title }}
      </li><img v-if="event.isWarning" class="excalmatory-mark" src="@/assets/attention_mark_mid.png">
    </div>
    <!-- </router-link> -->
</template>

<style scoped>
  .event-div{
    display: flex;
    align-items: center;
  }
  .event-item{
    width: 70%;
    text-align: left;
    margin-left: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .excalmatory-mark{
    height: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/EventCard.vue